import { BookOpen, Download, FileText, Megaphone } from "lucide-react";

const ROWS = [
  ["fr", "FR", "Guide d'utilisation", "XALTIX-Guide-utilisation"],
  ["en", "EN", "User Guide (UK / Suisse)", "XALTIX-User-Guide-EN"],
];
const BROCHURES = [
  ["fr", "FR", "Plaquette de présentation", "XALTIX-Plaquette-FR"],
  ["en", "EN", "Presentation brochure (UK / Suisse)", "XALTIX-Brochure-EN"],
];
const link = "inline-flex items-center gap-1.5 border border-slate-300 hover:bg-slate-50 px-3 py-2 rounded-md text-sm font-semibold transition-colors";

export const XaltixGuides = () => (
  <div data-testid="xaltix-guides" className="border border-slate-200 rounded-lg p-5 bg-white space-y-3">
    <div className="flex items-center gap-2"><BookOpen className="h-5 w-5 text-amber-600" /><h3 className="font-bold">Guides d'utilisation XALTIX</h3></div>
    {ROWS.map(([k, tag, label, file]) => (
      <div key={k} className="flex flex-wrap gap-2 items-center">
        <span className="text-xs font-bold text-slate-500 w-10">{tag}</span>
        <span className="text-sm text-slate-700 w-56">{label}</span>
        <a data-testid={`xaltix-guide-${k}-pdf`} href={`/guide/${file}.pdf`} download={`${file}.pdf`} className={link}><Download className="h-4 w-4" />PDF</a>
        <a data-testid={`xaltix-guide-${k}-docx`} href={`/guide/${file}.docx`} download={`${file}.docx`} className={link}><FileText className="h-4 w-4" />Word (modifiable)</a>
      </div>
    ))}
    <div className="border-t border-slate-100 pt-3 space-y-3" data-testid="xaltix-brochures">
      <div className="flex items-center gap-2"><Megaphone className="h-4 w-4 text-amber-600" /><span className="text-sm font-bold">Plaquettes commerciales (8 pages, sans tarifs)</span></div>
      {BROCHURES.map(([k, tag, label, file]) => (
        <div key={k} className="flex flex-wrap gap-2 items-center">
          <span className="text-xs font-bold text-slate-500 w-10">{tag}</span>
          <span className="text-sm text-slate-700 w-56">{label}</span>
          <a data-testid={`xaltix-brochure-${k}-pdf`} href={`/guide/${file}.pdf?v=1`} download={`${file}.pdf`} className={link}><Download className="h-4 w-4" />PDF</a>
          <a data-testid={`xaltix-brochure-${k}-docx`} href={`/guide/${file}.docx?v=1`} download={`${file}.docx`} className={link}><FileText className="h-4 w-4" />Word (modifiable)</a>
        </div>
      ))}
    </div>
    <div className="flex flex-wrap gap-2 items-center border-t border-slate-100 pt-3" data-testid="xaltix-guide-internal">
      <span className="text-xs font-bold text-amber-600 w-10">INT.</span>
      <span className="text-sm text-slate-700 w-56">Guide de l'espace XALTIX (interne)</span>
      <a data-testid="xaltix-guide-internal-pdf" href={`${process.env.REACT_APP_BACKEND_URL}/api/superadmin/guide/XALTIX-Guide-espace-XALTIX.pdf`} className={link}><Download className="h-4 w-4" />PDF</a>
      <a data-testid="xaltix-guide-internal-docx" href={`${process.env.REACT_APP_BACKEND_URL}/api/superadmin/guide/XALTIX-Guide-espace-XALTIX.docx`} className={link}><FileText className="h-4 w-4" />Word (modifiable)</a>
    </div>
  </div>
);
